export const firstLetterToUpperCase = (str: string): string =>
    `${str[0].toUpperCase()}{str.slice(1)}`;

export const snakeToCamel = (str: string): string =>
    str
        .toLowerCase()
        .replace(/([-_][a-z])/g, (match) => match[1].toUpperCase());

export const stringTrim = (str: string) =>
    str ? str.replace(/(^(\s|&nbsp;)+|(\s|&nbsp;)+$)/g, '') : str;
